import { useCallback } from 'react';
import { Product } from '../types/Product';

export const useShare = () => {
  const handleShare = useCallback(async (product: Product) => {
    const shareData = {
      title: product.display_name,
      text: product.description,
      url: product.share_url,
    };

    try {
      if (navigator.share && navigator.canShare(shareData)) {
        await navigator.share(shareData);
      } else {
        await navigator.clipboard.writeText(product.share_url);
        alert('Enlace copiado al portapapeles');
      }
    } catch (error) {
      // Handle error silently - sharing was probably cancelled
      console.log('Sharing cancelled or failed');
    }
  }, []);

  return { handleShare };
};